export enum FileTypes {
    IMAGES = "image/*",
    PDF = "application/pdf",
    ALL = "*",
}